var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v("如何提现【我的收益】")]),_c('van-icon',{attrs:{"name":"cross","size":"20"},on:{"click":_vm.close}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v("请使用电脑端登录 "),_c('span',{staticClass:"text-blue"},[_vm._v("http://author.talkgk.com")])]),_c('p',[_vm._v("进行结算收益的提现以及更多功能体验。")])])
}]

export { render, staticRenderFns }